import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import moment from 'moment'
import serverTimestamp from '../../utilities/Data/serverTimestamp'
import urlForUser from '../../utilities/urlForUser'
import styles from './PostSubtitle.icss'

const getDateFromTimestamp = timestamp => (timestamp && timestamp.toDate ? timestamp.toDate() : new Date(timestamp))

class PostTitleConditions extends Component {
	render() {
		const post = this.props.post
		const date = moment(getDateFromTimestamp(serverTimestamp(post.dateTimestamp)))
		const dateDisplay = date.format('ddd Do MMM')
		if (post.timeTakenHours) {
			date.add(post.timeTakenHours, 'h')
		}
		if (post.timeTakenMinutes) {
			date.add(post.timeTakenMinutes, 'm')
		}

		return this.context.translate('{userName}{locationComma}{location}, {dateDisplay}', {
			userName: {
				value: post.userName || '',
				display: value => <strong><Link className={styles.link} to={urlForUser({ userName: post.userName, uid: post.uid, isActivated: true })}>{value}</Link></strong>
			},
			locationComma: post.location ? ', ' : '',
			location: post.location,
			dateDisplay
		})
	}
}

PostTitleConditions.contextTypes = {
	translate: PropTypes.func
}

PostTitleConditions.propTypes = {
	post: PropTypes.object // eslint-disable-line react/forbid-prop-types
}

PostTitleConditions.defaultProps = {
	post: undefined
}

export default PostTitleConditions



// WEBPACK FOOTER //
// ./src/components/Item/PostSubtitle.jsx